import { render } from "./ArticleBasic.vue?vue&type=template&id=752db9e8&scoped=true"
import script from "./ArticleBasic.vue?vue&type=script&lang=js"
export * from "./ArticleBasic.vue?vue&type=script&lang=js"

import "./ArticleBasic.vue?vue&type=style&index=0&id=752db9e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-752db9e8"]])

export default __exports__